var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsurancePlanOverview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.27539 1.2824C7.74152 1.10118 8.25848 1.10118 8.72461 1.2824L13.0137 2.95036C13.6082 3.1816 13.9999 3.75386 14 4.39177V5.96111C13.9998 9.39123 12.1777 12.5628 9.21484 14.2912C8.46409 14.7291 7.53591 14.7291 6.78516 14.2912C3.82231 12.5628 2.00015 9.39123 2 5.96111V4.39177C2.00007 3.75386 2.39179 3.1816 2.98633 2.95036L7.27539 1.2824Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsurancePlanOverview);
export default __webpack_public_path__ + "static/media/insurance-plan-overview.9dfa8c7d00e9a48fe0d640cbdc8bafef.svg";
export { ForwardRef as ReactComponent };